import React, { useEffect } from 'react'
import celestial from 'd3-celestial'
import getLocation from '../../src/components/get-location'

const SkyViewer =
 ({ language }) => {
   const { longitude, latitude } = getLocation(language)
   const config = {
     container: 'celestial-map',
     datetime: new Date(),
     geopos: [latitude, longitude],
     lang: language,
     projection: 'aitoff', // orthographic
     form: false,
     controls: false,
     datapath: 'https://ofrohn.github.io/data/',
     width: 0,
     location: false,
     interactive: true,
     zoomlevel: 1,
     dsos: {
       show: true
     },
     stars: {
       propername: false,
       limit: 4
     },
     constellations: {
       names: false,
       lines: true
     },
     daylight: {
       show: true
     },
     horizon: {
       show: true
     }

   }
   const test = celestial.Celestial()

   useEffect(() => test.display(config))
   return (
     <div>
       <div style={{ overflow: 'hidden', margin: '0 auto' }}>
         <div id='celestial-map' />
       </div>
     </div>
   )
 }
export default SkyViewer
